import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BankIdService } from 'app/bankid/bankid.service';
import { BankIdClientV6 } from 'app/bankid';

@Component({
  selector: 'app-bankid-qr-code-modal',
  templateUrl: './bankid-qr-code-modal.component.html',
  styleUrl: './bankid-qr-code-modal.component.scss'
})
export class BankidQrCodeModalComponent implements OnInit {
  @Input() role_id: number;
  @Input() persnol_no: string;
  @Input() name: string;
  @Input() unique_id: string;
  @Input() apiRouteName: string;
  public qrcode: string;
  private orderRef: string;
  private cancelledBankId: boolean = false;
  constructor(
    private bankIdService: BankIdService,
    public activeModal: NgbActiveModal,
    private BankIdClientV6: BankIdClientV6,
  ) { }

  ngOnInit(): void {
    this.initBankidQrcode();
  }

  async initBankidQrcode() {
    const { orderRef, qr } = await this.bankIdService.signBankid(this.role_id, this.persnol_no, this.name, this.unique_id, this.apiRouteName);
    this.orderRef = orderRef;
    let success = false;
    // Generate new QR code for 30 seconds, check status of the order on each cycle
    for await (const newQrCode of qr.nextQr(orderRef, { timeout: 30 })) {
      if(this.cancelledBankId) {
        return;
      }
      this.qrcode = newQrCode;
      const resp = await this.BankIdClientV6.collect({ orderRef });
      if (resp.status === "complete") {
        // Check for success ?
        success = true;
        this.activeModal.close({ status: true, response: resp, orderRef:orderRef });
        return;
      } else if (resp.status === "failed") {
        // throw new Error(resp);
        success = true;
        this.activeModal.close({ status: false, orderRef:orderRef });
      }

      await new Promise(r => setTimeout(r, 2000));
    }
    if (!success) {
      this.activeModal.close({ status: false, orderRef:orderRef });
    }
  }
  
  cancelBankid(){
    this.cancelledBankId = true;
    this.BankIdClientV6.cancel({orderRef:this.orderRef});
    this.activeModal.close({status:false, orderRef:this.orderRef});
  }
}
